<div class="backdrop" [@backdropAnimation]="isOpen ? 'visible' : 'hidden'" (click)="closePopup()" *ngIf="isOpen"></div>
<div class="popup-wrapper" [@popupAnimation]="isOpen ? 'visible' : 'hidden'" *ngIf="isOpen">
  <div class="popup-box" [ngClass]="currentPopup?.cssClass || ''" [class.transparent-bg]="currentPopup?.hideBackground">
    <ng-container #popupHost></ng-container>
  </div>
</div>